import { AppStorage } from '../Basic/storage-service';
import { getWithAuth, postWithAuth } from '../Basic/HttpService';

export const getAuthenticatorCode = async (isToken) => {
    let config = isToken ? { headers: { Authorization: `Bearer ${isToken}` } } : { useAuthToken: true };
    let res = await getWithAuth('TwoFactorAuthentication/key', config);
    return res;
};

export const postAuthenticationCode = async (code, isToken) => {
    let config = isToken ? { headers: { Authorization: `Bearer ${isToken}` } } : { useAuthToken: true };
    let res = await postWithAuth(`TwoFactorAuthentication/Register2fa/${code}`, {}, config);
    return res;
};
export const postAuthenticationDisbaledCode = async (code) => {
    let res = await postWithAuth(`TwoFactorAuthentication/Disabled2FA/${code}`, {}, { useAuthToken: true });
    return res;
};
export const postAuthenticationValidateCode = async (code) => {
    let res = await postWithAuth(`/validate2fa/${code}`, {}, { withCredentials: true });
    if (res.success) {
        AppStorage.performLogin(res.data);
    }
    return res;
};
